"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var styles = function styles() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;z-index:1;display:flex;justify-content:flex-end;flex-wrap:wrap;padding:10px 12px 0 0;button{margin-left:12px;margin-bottom:10px;}")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("footer", {
  target: "css-ed6w180"
})(styles));

exports.default = _default;